<template>
  <v-card>
    <v-card-title primary-title>
      <div>
        <h3 class="headline mb-0">Usuario</h3>
      </div>
    </v-card-title>
    <v-container grid-list-xl fluid>
      <v-progress-linear indeterminate v-if="loadingData"></v-progress-linear>
      <v-layout row wrap v-if="!loadingData">
        <v-flex sm6>
          <v-text-field v-model="formData.email" label="Correo Electronico" placeholder="mail@ejemplo.com" readonly></v-text-field>
        </v-flex>
        <v-flex sm6>
          <v-text-field v-model="formData.rut" label="Rut" placeholder="xxx.xxx.xxx-x" mask="###.###.###-N" :rules="[rules.rut]" readonly></v-text-field>
        </v-flex>
        <v-flex sm6>
          <v-text-field v-model="formData.name1" label="Primer nombre" placeholder="Primer nombre" :rules="[rules.name1]" :error="(rules.name1 ? true : false)" readonly></v-text-field>
        </v-flex>
        <v-flex sm6>
          <v-text-field v-model="formData.name2" label="Segundo nombre" placeholder="Segundo nombre" :rules="[rules.name2]" :error="(rules.name2 ? true : false)" readonly></v-text-field>
        </v-flex>
        <v-flex sm6>
          <v-text-field v-model="formData.surname1" label="Apellido Paterno" :rules="[rules.surname1]" readonly></v-text-field>
        </v-flex>
        <v-flex sm6>
          <v-text-field v-model="formData.surname2" label="Apellido Materno" :rules="[rules.surname2]" readonly></v-text-field>
        </v-flex>
      </v-layout>
    </v-container>
    <!-- <v-card-actions>
        <v-btn flat color="primary" @click="submitForm">Guardar</v-btn>
    </v-card-actions> -->
  </v-card>
</template>


<script>
  import axios from 'axios';
  export default {
    data: () => ({
      formData: {},
      errors : {},
      loadingData : false,
      rules: {
        rut : false,
        name1 : false,
        name2 : false,
        surname1 : false,
        surname2 : false,
      }
    }),
    mounted () {
      axios.defaults.headers.post['Accept'] = 'application/json';
      axios.defaults.baseURL = 'https://auth.asistenciamobile.cl/api/';
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
      // localStorage.removeItem('token');
      this.getFormData();
      // console.log(localStorage.getItem('token'));
    },
    methods: {
      getFormData(){
        this.loadingData = true;
        let $this = this;
        axios.get( '/admin/account' )
             .then( function(response){
               $this.formData = response.data;
             })
             .finally(function(){
               $this.loadingData = false;
             });
      },
      submitForm(){
        let $this = this;
        axios.put( '/admin/account', this.formData )
             .then( function(){
               window.getApp.$emit('APP_RESOURCE_UPDATED', 'Datos actualizados.');
               $this.getFormData();
             })
             .catch(error => {
               if(error.response.status == 422){
                 $this.rules = {...$this.rules, ...error.response.data.errors};
               }
             })
             .finally(function () {

             });
      }
    }
  }
</script>
